import PatTry from "../../../../football/rules/offensive/pat/pat-try";

export default class FlagPatTry extends PatTry {
    kickoffContextChanges(gameContext) {
        gameContext.setDriveContext({
            triggerDrive: true
        });
    }
}
